import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import MyTeamInterface from "../aggregates/MyTeamInterface";
// Define a type for the slice state

// Define the initial state using that type

const myTeamSlice = createSlice({
  name: "myTeam",

  initialState: { team: [], teamRefresh: false },
  reducers: {
    myTeamReducer: (state: any, action: PayloadAction<MyTeamInterface>) => {
      state.team = action.payload;
    },
    setMyTeamLoading: (state: any, action: PayloadAction<any>) => {
      state.teamRefresh = action.payload;
    },
    resetMyTeam: (state: any) => {
      state.team = [];
    },
  },
});

export const { myTeamReducer, resetMyTeam, setMyTeamLoading } =
  myTeamSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default myTeamSlice.reducer;
